import React from "react";
import Titulo from "./Titulo";
import AccionesVista from "./Menu/AccionesVista";
import { CardTitle } from "reactstrap";
import { getAtributo } from "../context/FuncionesContext";

const HeaderConf = ({ opciones, className, dato }) => {

  if (!opciones || !opciones.tipo) return <></>;
  const classNoTitulo = [24, 2].includes(opciones.tipo.id)
    ? "menu_listado_no_titulo"
    : "menu_vista_no_titulo";

  return (
    <CardTitle
      id={opciones.id_a + "_HEADERCONF"}
      className={`tarjeta_titulo ${opciones.titulo_imprimible === 'n' ? 'd-print-none' : ''}`}
      style={{ position: "relative", margin: "0" }}
    >
      {opciones.titulo && opciones.pantalla_usar_titulo !== "n" ? (
        <>
          <Titulo
            tag={opciones.titulo_tag}
            titulo={getAtributo("titulo", dato, opciones) || opciones.titulo}
            className={className}
          />
        </>
      ) : (
        <></>
      )}

      {opciones.tipo?.id === 1 && opciones.titulo ? (
        <>
          {" "}
          <AccionesVista
            opciones={opciones}
            className={` ${!opciones.titulo || opciones.titulo === ""
              ? classNoTitulo
              : "menu_vista_no_listado"
              }`}
            datos={dato}
          />
        </>
      ) : (
        <AccionesVista
          opciones={opciones}
          className={` ${!opciones.titulo || opciones.titulo === ""
            ? classNoTitulo
            : "menu_vista_no_listado"
            }`}
          datos={dato}
        />
      )}
    </CardTitle>
  );
};

export default HeaderConf;
